<script setup lang="ts">
import type { ListboxFilterProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';
import { reactiveOmit } from '@vueuse/core';
import { Search } from 'lucide-vue-next';
import { ListboxFilter, useForwardProps } from 'reka-ui';
import { cn } from '@/lib/utils';
import { useCommand } from '.';

defineOptions({
    inheritAttrs: false,
});

const props = defineProps<
    ListboxFilterProps & {
        class?: HTMLAttributes['class'];
    }
>();

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);

const { filterState } = useCommand();
</script>

<template>
    <div class="flex items-center border-b px-3" cmdk-input-wrapper>
        <Search class="mr-2 h-4 w-4 shrink-0 opacity-50" />
        <ListboxFilter
            v-bind="{ ...forwardedProps, ...$attrs }"
            v-model="filterState.search"
            auto-focus
            :class="
                cn(
                    'placeholder:text-muted-foreground h-10 min-w-0 flex-1 rounded-md bg-transparent py-3 text-sm outline-none disabled:cursor-not-allowed disabled:opacity-50',
                    'text-base', // atNorth overrides, TODO: put into a wrapper component
                    props.class,
                )
            "
        />
        <div v-if="$slots.trailing" class="ml-2 shrink-0">
            <slot name="trailing" />
        </div>
    </div>
</template>
